import React, { useEffect, useState } from 'react';
import { classIf } from '../../data/utils/classIf';
import { PrematchContext } from '../Prematch';
import { BreadcrumbContext } from './BreadcrumbContext';

function SportBreadcrumb(props) {
    const prematchContext = React.useContext(PrematchContext);
    const breadcrumbContext = React.useContext(BreadcrumbContext);
    const [dropdownToggled, setDropdownToggled] = useState(false);

    function toggleDropdown() {
        if (dropdownToggled) {
            setDropdownToggled(false);
        } else {
            breadcrumbContext.setType('sport');
        }
    }

    useEffect(() => {
        if (breadcrumbContext && breadcrumbContext.type) {
            if (breadcrumbContext.type === 'sport' && !dropdownToggled) {
                setDropdownToggled(true);
            } else if (dropdownToggled) {
                setDropdownToggled(false);
            }
        }
    }, [breadcrumbContext]);

    return (
        <span className="nav-breadcrumb" onClick={toggleDropdown}>
            {props.desc}
            {dropdownToggled &&
                <div className="nav-dropdown">
                    {prematchContext.applyTemporalFilter(props.sports).map(s => {
                        function handleClick() {
                            prematchContext.openSport(s);
                        }
                        const selected = s.id === props.selected;
                        return (
                            <div key={s.id} className={"event-desc text-small" + classIf(selected, 'selected')} onClick={handleClick}>
                                <span>{s.descrizione}</span>
                            </div>
                        )
                    })}
                </div>
            }
        </span>
    );
}

export default SportBreadcrumb;